import React from "react";

export default function IconRequestSent() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_633_206)">
        <path
          d="M16.5218 18.6957H15.8696V15.2174C15.8696 12.9455 14.5698 10.9752 12.6769 10C14.5892 9.01484 15.8696 7.03656 15.8696 4.78262V1.30434H16.5218C16.8819 1.30434 17.174 1.01242 17.174 0.652148C17.174 0.291914 16.8819 0 16.5218 0C13.9061 0 6.12031 0 3.47836 0C3.11832 0 2.82617 0.291914 2.82617 0.652188C2.82617 1.01246 3.11832 1.30438 3.47836 1.30438H4.13055V4.78266C4.13055 7.03625 5.41066 9.01473 7.32328 10C5.43035 10.9752 4.13055 12.9455 4.13055 15.2174V18.6957H3.47836C3.11832 18.6957 2.82617 18.9876 2.82617 19.3479C2.82617 19.7082 3.11832 20.0001 3.47836 20.0001C7.83465 20.0001 12.1697 20.0001 16.5218 20.0001C16.8819 20.0001 17.174 19.7082 17.174 19.3479C17.174 18.9876 16.8819 18.6957 16.5218 18.6957ZM5.4548 5.17621C5.42289 4.80477 5.43484 4.96309 5.43484 1.30434H14.5653C14.5653 4.96309 14.5773 4.80477 14.5454 5.17621H5.4548ZM14.5653 17.9555C10.9675 14.9573 11.0986 15.0113 10.6523 14.8536V14.1304C10.6523 13.7702 10.3601 13.4782 10.0001 13.4782C9.64004 13.4782 9.34789 13.7702 9.34789 14.1304V14.8535C8.90621 15.0096 9.04445 14.9474 5.43484 17.9555V15.2174C5.43484 12.9221 7.13914 11.0224 9.34789 10.7043V11.5217C9.34789 11.882 9.64004 12.1739 10.0001 12.1739C10.3601 12.1739 10.6523 11.882 10.6523 11.5217V10.7043C12.861 11.0224 14.5653 12.9221 14.5653 15.2174V17.9555Z"
          fill="#"
        />
      </g>
      <defs>
        <clipPath id="clip0_633_206">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
